import { render } from "./ServerDocumentPreview.vue?vue&type=template&id=6684e79f&scoped=true"
import script from "./ServerDocumentPreview.vue?vue&type=script&lang=js"
export * from "./ServerDocumentPreview.vue?vue&type=script&lang=js"

import "./ServerDocumentPreview.vue?vue&type=style&index=0&id=6684e79f&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6684e79f"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
